import { render } from "./ActiveColorStyle.vue?vue&type=template&id=0f5627d6"
import script from "./ActiveColorStyle.vue?vue&type=script&lang=ts"
export * from "./ActiveColorStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script